import { render, staticRenderFns } from "./PortfolioDashboard.vue?vue&type=template&id=234d1796&"
import script from "./PortfolioDashboard.vue?vue&type=script&lang=js&"
export * from "./PortfolioDashboard.vue?vue&type=script&lang=js&"
import style0 from "./less/portfolioDashboard.less?vue&type=style&index=0&module=true&lang=css&"

var cssModules = {}
var disposed = false

function injectStyles (context) {
  if (disposed) return
  
        cssModules["$style"] = (style0.locals || style0)
        Object.defineProperty(this, "$style", {
          configurable: true,
          get: function () {
            return cssModules["$style"]
          }
        })
      
}


  module.hot && module.hot.dispose(function (data) {
    disposed = true
  })



        module.hot && module.hot.accept(["./less/portfolioDashboard.less?vue&type=style&index=0&module=true&lang=css&"], function () {
          var oldLocals = cssModules["$style"]
          if (oldLocals) {
            var newLocals = require("./less/portfolioDashboard.less?vue&type=style&index=0&module=true&lang=css&")
            if (JSON.stringify(newLocals) !== JSON.stringify(oldLocals)) {
              cssModules["$style"] = newLocals
              require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js").rerender("234d1796")
            }
          }
        })

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('234d1796')) {
      api.createRecord('234d1796', component.options)
    } else {
      api.reload('234d1796', component.options)
    }
    module.hot.accept("./PortfolioDashboard.vue?vue&type=template&id=234d1796&", function () {
      api.rerender('234d1796', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/views/portfolioDashboard/PortfolioDashboard.vue"
export default component.exports